import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=0236db4e&scoped=true"
import script from "./ProductListItem.vue?vue&type=script&lang=js"
export * from "./ProductListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=0236db4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236db4e",
  null
  
)

export default component.exports